<template>
  <v-container id="clientes" tag="section">
    <base-v-component heading="Contabilidad del sistema " />
    <base-material-card
      color="indigo"
      icon="mdi-newspaper"
      inline
      class="px-5 py-3"
    >
      <v-row>
        <v-col cols="12" md="4">
          <v-select
            label="Trimestre fiscalizar"
            :items="mesesTrimestreItems"
            v-model="mesesTrimestre"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-btn
            color="primary"
            :loading="exportarLoading"
            @click="exportar"
            :disabled="!mesesTrimestre"
            >Exportar</v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field label="Buscar pago" v-model="buscarPagoModel" />
        </v-col>
        <v-col cols="12" md="4">
          <v-btn
            color="primary"
            :loading="buscarPagoLoading"
            @click="buscarPagoMetodo"
            :disabled="!buscarPagoModel"
            >Buscar</v-btn
          >
        </v-col>
      </v-row>
      <v-row v-if="!!pago">
        <v-col cols="12" md="4">
          <v-text-field
            outlined
            readonly
            rounded
            dense
            label="Código pago"
            v-model="pago.codigoFactura"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            outlined
            readonly
            rounded
            dense
            label="Fecha"
            v-model="pagoMostrar.fechaMostrar"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-btn
            outlined
            rounded
            dense
            label="Fecha"
            @click="$router.push('/admin/negocio/pedidos/ver/' + pago.pedido)"
            >Ver pedido</v-btn
          >
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            outlined
            readonly
            rounded
            dense
            label="Base imponible"
            v-model="pagoMostrar.baseImponiblePago"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            outlined
            readonly
            rounded
            dense
            label="Impuestos"
            v-model="pagoMostrar.impuestosTotalesPago"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            outlined
            readonly
            rounded
            dense
            label="Total"
            v-model="pagoMostrar.pagadoMostrar"
          />
        </v-col>
      </v-row>
      <!-- <v-row>
        <v-col cols="12" md="4">
          <v-btn
            outlined
            rounded
            dense
            label="Fecha"
            @click="arreglarContabilidad"
            >Arreglar contabilidad</v-btn
          >
        </v-col>
      </v-row> -->
    </base-material-card>
  </v-container>
</template>
    
<script>
import moment from "moment-timezone";
import { mostrarMoneda } from "@/utils/utils.js";

export default {
  data: () => {
    return {
      mesesTrimestre: null,
      exportarLoading: false,
      buscarPagoModel: "", //"FT0020000001478",
      buscarPagoLoading: false,
      pago: null,
    };
  },
  computed: {
    pagoMostrar() {
      return this.pago
        ? {
            ...this.pago,
            fechaMostrar: moment
              .unix(this.pago.moment)
              .format("DD-MM-YYYY HH:mm"),
            pagadoMostrar: mostrarMoneda(this.pago.pagado),
          }
        : false;
    },
    mesesTrimestreItems() {
      let nombres = [
        "Enero, febrero, marzo",
        "Abril, mayo, junio",
        "Julio, agosto, septiembre",
        "Octubre, noviembre, diciembre",
      ];
      let actualTrimestre = moment().quarter();
      return [1, 2, 3, 4].map((t) => {
        let aux = t <= actualTrimestre;
        const start = aux
          ? moment().quarter(t).startOf("quarter")
          : moment().quarter(t).startOf("quarter").subtract(1, "year");
        const end = aux
          ? moment().quarter(t).endOf("quarter")
          : moment().quarter(t).endOf("quarter").subtract(1, "year");
        // const end = moment().quarter(t).endOf("quarter");
        return {
          text: nombres[t - 1] + (aux ? " (año en curso)" : " (año anterior)"),
          value: [start, end, nombres[t - 1]],
        };
      });
    },
  },
  methods: {
    arreglarContabilidad() {
      this.$store.dispatch("contabilidad/arreglarContaiblidad");
    },
    buscarPagoMetodo() {
      this.buscarPagoLoading = true;
      this.$store
        .dispatch("contabilidad/buscarPago", this.buscarPagoModel)
        .then((pago) => {
          this.pago = pago;
          // console.log(r.pedido);
          // console.log(r.pago);
        })
        .finally(() => {
          this.buscarPagoLoading = false;
        });
    },
    exportar() {
      this.exportarLoading = true;
      this.$store
        .dispatch("contabilidad/exportarTrimestre", this.mesesTrimestre)
        .finally(() => (this.exportarLoading = false));
    },
  },
};
</script>
    


<style>
</style>